type Props = {
  size: number;
  color?: string;
};

const Smoking = ({ size, color }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.1334 15.1472H3.8934C3.25275 15.1472 2.7334 15.6666 2.7334 16.3072V18.6272C2.7334 19.2679 3.25275 19.7872 3.8934 19.7872H20.1334C20.774 19.7872 21.2934 19.2679 21.2934 18.6272V16.3072C21.2934 15.6666 20.774 15.1472 20.1334 15.1472Z"
        stroke={color || '#868686'}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M17.7437 15.8779V19.7871"
        stroke={color || '#868686'}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M19.1937 11.76C19.1937 10.6 21.2817 10.6 21.2817 9.44005C21.2817 8.28005 19.1937 8.28005 19.1937 7.12005C19.1937 5.96005 21.2817 5.96005 21.2817 4.80005"
        stroke={color || '#868686'}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Smoking;
